<template>
  <div>
    <div class="mt-order-top" style="height: auto;">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单搜索：">
          <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
        </el-form-item>
        <el-form-item label="时间筛选：">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button @click="exportExcelBtn" v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button>
    </div>
    <div>
      <el-table
        :data="infoList"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="orderNo"
          label="订单号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="nickName"
          label="昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realPayMoney"
          label="实付金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="deliveryType"
          label="退款类型">
          <template slot-scope="scope">
            <span>{{scope.row.deliveryType == 2 ? '退货退款' : '仅退款'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="refundReason"
          label="退款理由">
        </el-table-column>
        <el-table-column
          align="center"
          prop="refundImgList"
          label="备注图片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.refundImgList != null"
              style="width: 32px;"
              :src="scope.row.refundImgList[0]"
              :preview-src-list="scope.row.refundImgList"
              fit="contain"></el-image>
            <span v-if="scope.row.refundImgList == null">--</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="申请时间">
        </el-table-column>
        <el-table-column
          align="center"
          width="240"
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detailOpenBtn(scope.row.id)">订单详情</el-button>
            <el-button v-if="tabCurrent == 3" type="text" size="small" @click="wlOpenBtn(scope.row.id)">物流信息</el-button>
            <el-button v-if="tabCurrent == 0 || tabCurrent == 3" @click="applyOrderOpenBtn(scope.row.deliveryType, scope.row.id, scope.row.realPayMoney)" type="text" size="small">审核</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
    </div>
    <!-- 订单详情弹窗 -->
    <el-drawer
      size="960px"
      :visible.sync="detailShow"
      :with-header="false">
      <after-sale-detail :infoId="infoId" @applyOrderInfo="applyOrderGetValue"></after-sale-detail>
    </el-drawer>
    <!-- 物流详情弹窗 -->
    <el-drawer
      size="960px"
      :visible.sync="wlInfoShow"
      :with-header="false">
      <after-sale-wl :infoId="infoId"></after-sale-wl>
    </el-drawer>
    <!-- 审核退款弹窗 -->
    <el-dialog
      title="审核退款"
      :visible.sync="applyOrderShow"
      width="960px">
      <el-form :model="applyOrderForm" label-width="140px">
        <el-form-item label="审核意见：">
          <el-radio-group v-model="applyOrderForm.refundStatus">
            <el-radio :label="1">{{tabCurrent == 0 ? '通过' : '已收到（通过）'}}</el-radio>
            <el-radio :label="2">{{tabCurrent == 0 ? '驳回' : '未收到（驳回）'}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="applyOrderForm.refundStatus == 1 && deliveryType != 1" label="退款金额：">
          <el-input style="width: 420px;" v-model="applyOrderForm.refundMoney" :placeholder="'￥ '+realPayMoney+'（默认退款金额，可修改）'"></el-input>
        </el-form-item>
        <el-form-item v-if="applyOrderForm.refundStatus == 2" label="">
          <el-input rows="5" style="width: 420px;" type="textarea" v-model="applyOrderForm.auditFailReason" placeholder="请输入驳回理由"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="applyOrderSaveBtn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { orderList, auditRefund, auditRefundStatus, orderExportExcel } from '@/api/afterSale'
import AfterSaleDetail from './AfterSaleDetail.vue'
import OrderSend from './Send.vue'
import AfterSaleWl from './AfterSaleWl.vue'
export default {
  name: 'AfterSaleSingle',
  components: {
    AfterSaleDetail,
    OrderSend,
    AfterSaleWl
  },
  props: {
    tabCurrent: {
      type: Number,
      default: 0
    }
  },
  watch: {
    "tabCurrent"(newVal, oldVal) {
      this.currentPage = 1;
      this.getInfoList();
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        date:['', '']
      },
      activeName:'first',
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:'',
      // 订单详情
      detailShow:false,
      // 申请退款订单弹窗
      deliveryType:'',
      realPayMoney:'0.00',
      applyOrderShow:false,
      applyOrderForm:{
        refundMoney: '',
        refundStatus:1,
        auditFailReason:''
      },
      // 物流信息弹窗
      wlInfoShow:false
    }
  },
  mounted () {
    var that = this;
    that.getInfoList();
  },
  methods: {
    /* 取子组件"OrderDetail"传值 */
    applyOrderGetValue(applyOrderShow, infoId){
      if(applyOrderShow == 1){
        this.detailShow = false;
      }
      this.infoId = infoId;
      this.applyOrderShow = true;
    },
    /* 取子组件"OrderSend"传值 */
    applyOrderSaveGetValue(applyOrderShow, infoId){
      if(applyOrderShow == 2){
        this.getInfoList();
      }
      this.infoId = infoId;
      this.applyOrderShow = false;
    },
    // 导出操作
    exportExcelBtn(){
      let that = this
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      that.fullscreenLoading = true;
      orderExportExcel({webSearchQuery: searchName, startCreateDate: startDate, endCreateDate: endDate, refundStatus: tabCurrent}).then((res) => {
        that.fullscreenLoading = false;
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '退款列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // 申请退款订单弹窗-打开操作
    applyOrderOpenBtn(deliveryType, infoId, realPayMoney){
      this.infoId = infoId;
      this.realPayMoney = realPayMoney;
      this.deliveryType = deliveryType;
      this.applyOrderShow = true;
    },
    // 申请退款订单弹窗-保存操作
    applyOrderSaveBtn(){
      var infoId = this.infoId;
      var applyOrderForm = this.applyOrderForm;
      var deliveryType = this.deliveryType;
      if(applyOrderForm.refundMoney == '' && applyOrderForm.refundStatus == 1 && deliveryType == 1){
        this.$message.error('请输入退款金额');
        return false;
      }
      if(applyOrderForm.auditFailReason == '' && applyOrderForm.refundStatus == 2){
        this.$message.error('请输入驳回理由');
        return false;
      }
      var passData = applyOrderForm;
      passData.id = infoId;
      var that = this;
      if(deliveryType == 1){
        // 退货退款第一次审核
        auditRefundStatus(passData).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.$message.success('操作成功');
            that.applyOrderShow = false;
            that.getInfoList();
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg);
          }
        })
      }else{
        auditRefund(passData).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.applyOrderShow = false;
            that.getInfoList();
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg);
          }
        })
      }
    },
    /* 打开详情操作 */
    detailOpenBtn(infoId){
      this.infoId = infoId;
      this.detailShow = true;
    },
    /* 打开物流信息弹窗操作 */
    wlOpenBtn(infoId){
      this.infoId = infoId;
      this.wlInfoShow = true;
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      orderList({ webSearchQuery: searchName, startCreateDate: startDate, endCreateDate: endDate, pageNum: page, pageSize: that.limitLength, refundStatus:tabCurrent}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/AfterSaleSingle.vue